import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        userCode: '',
        session: '',
        appId: 0,
        activityId: 0
    },
    getters: {
        params: state => {
            return {
                userCode: state.userCode,
                session: state.session,
                appId: state.appId,
                activityId: state.activityId
            }
        }
    },
    mutations: {
        setParam (state, info) {
            state.userCode = info.userCode;
            state.session = info.session;
            state.appId = info.appId;
            state.activityId = info.activityId;
        }
    },
    actions: {

    }
})
